// pages/Home.jsx
export default function Home() {
  return <h1>Dashboard Home</h1>;
}